import React, { useEffect } from "react";
import "./Registration.css";
import { useState } from "react";
import Forfmsubmit from "../../components/Loader/Forfmsubmit";
import PaymentLoader from "../../components/Loader/PaymentLoader";
import ManualAlertpage from "../../components/Alert/ManualAlertpage";

const Register = () => {

  const [loader, setloader] = useState(false)
  const [loader2, setloader2] = useState(false)
  const [tranx, settranx] = useState(false)
  const [payementerror, setpayementerror] = useState("")
  const [isvalid, setisvalid] = useState(false)
  const [Data, setData] = useState({ fullname: "", number: "", email: "", dob: "", course: "", message: "", totalamount: 0, registrationamount: "", trnxid: "" })
  const [error, seterror] = useState({ fullname: "", number: "", email: "", dob: "", course: "", message: "", registrationamount: "" })

  // after submission 

  const [submissionpage, setsubmissionpage] = useState(false); // for enable Submission page 
  const [Submissiondata, setSubmissiondata] = useState({})

  const toggleFn = () => {
    setsubmissionpage(!submissionpage);
  }

  // Function for validation
  const handleError = (field, value) => {
    const errorCopy = { ...error };

    switch (field) {
      case "fullname":
        if (!value) { errorCopy.fullname = "*Please fill your name*" } else { errorCopy.fullname = ""; }
        break;
      case "number":
        if (!value) { errorCopy.number = "*Please fill your number*" } else if (value.length !== 10) { errorCopy.number = "*Please enter a valid number with 10 digits*"; } else { errorCopy.number = ""; }
        break;
      case "email":
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!value) { errorCopy.email = "*Please fill your email*"; } else if (!emailRegex.test(value)) { errorCopy.email = "*Please enter a valid email*"; } else { errorCopy.email = ""; }
        break;
      case "dob":
        if (!value) { errorCopy.dob = "*Please fill your DOB*"; } else { errorCopy.dob = ""; }
        break;
      case "course":
        if (value == "") { errorCopy.course = "*Please select a course*"; } else { errorCopy.course = ""; }
        break;
      case "registrationamount":
        if (!value) {
          errorCopy.registrationamount = "*Please fill registration amount*";
        } else if (value < 500) {
          errorCopy.registrationamount = "*Minimum registration amount is Rs.500*";
        } else if (value > Data.totalamount) {
          errorCopy.registrationamount = "*Registration amount cannot exceed total fees*";
        } else {
          errorCopy.registrationamount = "";
        }
        break;
      default:
        break;
    }

    seterror(errorCopy);
  };



  const handleCourseSelect = () => {

    let amount = 0;

    switch (Data.course) {
      case "Java Full Stack Web Development":
        amount = 6999;
        break;
      case "Full Stack Web Development":
        amount = 11999;
        break;
      case "Python and Datascience":
        amount = 6999;
        break;
      case "Artificial Intelligence & Machine Learning":
        amount = 11499;
        break;
      case "AWS Cloud Architect":
        amount = 6999;
        break;
      case "DevOps":
        amount = 3999;
        break;
      default:
    }

    setData((prevData) => ({
      ...prevData,
      totalamount: amount,
    }));
  };

  const handleBeforeUnload = (event) => {

    const message = 'Are you sure you want to leave? You may lose unsaved changes.';

    event.returnValue = message;
    return message;
  };
  // useeffect hook 
  useEffect(() => {
    if (Data.course) {
      handleCourseSelect()
    }

    Enablebtn()
  }, [Data.course, isvalid])

  useEffect(() => {
    if (Data.course) {
      handleCourseSelect();
    }
    Enablebtn();
  }, [Data.course, error]);

  const Enablebtn = () => {
    const isEmailValid = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(Data.email);

    if (
      !Data.fullname ||
      Data.number.length !== 10 ||
      !isEmailValid ||
      !Data.dob ||
      !Data.course ||
      Data.registrationamount > Data.totalamount ||
      Data.registrationamount < 500
    ) {
      setisvalid(false); // Disable button
    } else {
      setisvalid(true); // Enable button
    }
  };


  // handlechange hook 
  const handlechange = (e) => {
    const { name, value } = e.target

    setData({
      ...Data,
      [name]: value,
    })

    handleError(name, value);
  }

  const handlesubmit = async (e) => {
    e.preventDefault()
    if (isvalid) {
      try {
        seterror({ fullname: "", number: "", email: "", dob: "", course: "", message: "", registrationamount: "" })
        setloader(true)
        const Response = await fetch("https://icoeess-backend-06-feb-2025-icoessbackend.onrender.com/api/ordercreate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(Data)
        })

        const Result = await Response.json()

        if (Response.ok && Result.data.id) {

          if (payementerror) {
            setpayementerror("")
          }

          const options = {

            key: "rzp_live_zJ4YoQj9OmAUDm",
            image: "https://icoesolution.com/assets/icoess-logo.png",
            currency: Result.data.currency,
            orderid: Result.data.id,
            amount: Result.data.amount,
            name: "Icoess Solutions",

            handler: async function (event) {
              const paymentid = await event.razorpay_payment_id;
              window.addEventListener("beforeunload", handleBeforeUnload)
              setData((prevadata) => ({
                ...prevadata,
                trnxid: paymentid,
                receiptno: Result.data.receipt
              }))
              settranx(true)
            },
            prefill: {
              name: Data.fullname,
              contact: Data.number,
              email: Data.email
            },
            theme: {
              color: "crimson"
            }
          }

          const Razorpaywindow = new window.Razorpay(options)
          Razorpaywindow.open();
        }
        else {
          setpayementerror("Payment failed so Please try again.");
        }
      }
      catch (error) {
        setpayementerror("An error occurred while processing the payment.");
      }
      finally {
        setloader(false)
      }
    }
  }

  const handlesubmitmainform = async () => {
    try {
      setloader2(true)
      const PostDataapi = await fetch("https://icoeess-backend-06-feb-2025-icoessbackend.onrender.com/api/mailsend", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(Data)
      })

      const Resultdata = await PostDataapi.json();
      if (Resultdata.status === "success") {
        settranx(false)
        setData({ fullname: "", number: "", email: "", dob: "", course: "", message: "", totalamount: "", registrationamount: "", trnxid: "" })
        setsubmissionpage(true);
        setSubmissiondata({
          message: "Thank You!! for registering to ICOESS's Technical training program.",
          context: `A confirmation E-mail has been sent on <strong>${Data.email}</strong>. Please take a note of your payment <strong>Transaction id: </strong><span style="color:#0c94f1;">${Data.trnxid}</span> for future reference.`,
          context2: "For any further inquires,please contact on <a href='mailto:girjesh.mishra@icoesolution.com' target='_blank' style='color:#0c94f1;'>girjesh.mishra@icoesolution.com</a>",
          btnname: "Ok"
        })
      }
      else {
        setpayementerror(Resultdata.message);
      }
    }
    catch (err) {
      setpayementerror("Mail is not Sent on your gmail so please contact with Icoess Solution Pvt. Ltd.")
    }
    finally {
      setloader2(false)
    }
  }
  const oncancel = () => {
    setData({ fullname: "", number: "", email: "", dob: "", course: "", message: "", trnxid: "", totalamount: 0, registrationamount: "" })
  }

  // loader 

  if (loader2) {
    return <Forfmsubmit />
  }

  if (loader) {
    return <PaymentLoader />
  }

  return (
    <>
      <div className="contacts-page-container">
        <div className="img"></div>

        <div className="contact-Form">
          <form action='POST' className="form" onSubmit={handlesubmit}>
            <h2>Register</h2>

            <label htmlFor="fullname" class="inputBox">
              <input type="text" name="fullname" onChange={handlechange} value={Data.fullname} id="fullname" className="inputfield" readOnly={tranx} onInput={(e) => handleError("fullname", e.target.value)} required />
              <span className="content">Full Name</span>
              {error.fullname && <p className="error-text">{error.fullname}</p>}
            </label>

            <label htmlFor="number" class="inputBox">
              <input type="number" name="number" onChange={handlechange} value={Data.number} id="number" readOnly={tranx} onInput={(e) => handleError('number', e.target.value)} required />
              <span>Phone</span>
              {error.number && <p className="error-text">{error.number}</p>}
            </label>

            <label htmlFor="email" class="inputBox">
              <input type="email" name="email" onChange={handlechange} value={Data.email} id="email" readOnly={tranx} onInput={(e) => handleError("email", e.target.value)} required />
              <span>Email</span>
              {error.email && <p className="error-text">{error.email}</p>}
            </label>

            <label htmlFor="dob" class="inputBox">
              <input className="special-input" type="date" name="dob" onChange={handlechange} value={Data.dob} id="dob" readOnly={tranx} onInput={(e) => handleError("dob", e.target.value)} />
              <span className="special-validate">DOB</span>
              {error.dob && <p className="error-text">{error.dob}</p>}
            </label>

            <label htmlFor="course" class="inputBox">
              <select name="course" id="course" onChange={(e) => { handlechange(e); handleError("course", e.target.value) }} value={Data.course} disabled={tranx} >
                <option value={""} selected disabled>Select Course</option>
                <option value="Java Full Stack Web Development">Java Full Stack Web Development</option>
                <option value="Full Stack Web Development">Full Stack Web Development</option>
                <option value="Python and Datascience">Python and Datascience</option>
                <option value="Artificial Intelligence & Machine Learning">Artificial Intelligence & Machine Learning</option>
                <option value="DevOps">DevOps</option>
                <option value="AWS Cloud Architect">AWS Cloud Architect</option>
              </select>
              <span className="special-valiadte">Select Course</span>
              {error.course && <p className="error-text">{error.course}</p>}
            </label>

            <label htmlFor="totalamount" class="inputBox registration-amount">
              <input type="text" name="totalamount" id="totalamount" onChange={handlechange} value={"₹ " + Data.totalamount} readOnly required />
              <span>Total Fees Amount</span>
            </label>

            <label htmlFor="registrationamount" class="inputBox registration-amount">
              <input type="number" name="registrationamount" id="registrationamount" onChange={handlechange} value={Data.registrationamount} onInput={(e) => handleError("registrationamount", e.target.value)} required disabled={tranx} />
              <span>Registration Amount</span>
              {error.registrationamount && <p className="error-text">{error.registrationamount}</p>}
            </label>

            <label htmlFor="amount" class="inputBox registration-amount">
              <input type="text" className="trnxidclass" name="trnxid" id="trnxid" onChange={handlechange} value={Data.trnxid} disabled />
              <span>Your Transaction Id</span>
            </label>

            {tranx ? (<button type="button" id="disablebtnpaynow">Pay Now ₹{Data.registrationamount}</button>) : (
              <div className="inputBox amount-btn-pay-box">
                {isvalid ? (<button type="submit" id="paynowbtn">Pay now ₹{Data.registrationamount}</button>) : (<button type="button" id="disablebtnpaynow">Pay Now</button>)}
              </div>
            )}

            <div className="manage-div-fields">

              <label htmlFor="message" class="textarea">
                <textarea name="message" id="message" onChange={handlechange} value={Data.message}></textarea>
                <span>(Optional) Type your Message...</span>
                {error.message && <p className="error-text">{error.message}</p>}
              </label>

              {payementerror && <p className="payment-error">{payementerror}</p>}

              <div className="btn-div">
                {tranx ? (<button type="button" id="disablebtn">Cancel</button>) : (<button type="button" id="cancelbtn" onClick={oncancel}>Cancel</button>)}
                {!tranx ? (<button id="disablebtn" disabled>Submit</button>) : (<button type="button" onClick={handlesubmitmainform} id="submitbtn">Submit</button>)}
              </div>
            </div>
          </form>
        </div>
      </div>
      {submissionpage &&
        <ManualAlertpage
          message={Submissiondata.message}
          context={Submissiondata.context}
          context2={Submissiondata.context2}
          btnname={Submissiondata.btnname}
          close={submissionpage}
          togglebox={toggleFn} />
      }
    </>
  );
}

export default Register;